import * as React from 'react';
import { arrayMove } from "react-sortable-hoc";

export function useArray<T>(array: T[]) {
    const [data, setData] = React.useState<T[]>(array || []);

    function add(value: T) {
        setData([...data, value]);
    }

    function update(value: T, index: number) {
        const modifiedData = [...data];
        modifiedData[index] = value;
        setData([...modifiedData])
    }

    function remove(index: number) {
        const modifiedData = data.filter((item: T, i: number) => index !== i);
        setData(modifiedData)
    }

    function reorder(oldIndex: number, newIndex: number) {
        setData(old => arrayMove(old, oldIndex, newIndex))
    }

    return {
        data,
        add,
        remove,
        reorder,
        update
    }
}